import ReactBootstrapSlider from 'react-bootstrap-slider';
import React, { useCallback } from 'react';

export default function LineParameters(props) {
    let {line} = props;
    if (line === undefined) {
        return (
            <div></div>
        );
    }

    const onChange = useCallback((value) => {
        console.log('on change value = ' + value);
        props.onChangeValue({brightness: value});
    }, []);

    let value = line.brightness || 1;
    return (
        <div className="line-parameters">
          <div>
            Brightness: {value}
          </div>
          <ReactBootstrapSlider
            value={parseFloat(value)}
            change={(e) => onChange(e.target.value)}
            step={0.01}
            max={1}
            min={0}
            orientation="horizontal"
            reversed={false}
            />
        </div>
    );
}
